import React from "react";
import { Link as RouterLink } from "react-router-dom";
import { useNavigate } from "react-router-dom";

// Icons
import { MdOutlineMessage } from "react-icons/md";
import { IoIosNotificationsOutline } from "react-icons/io";
import { IoPersonOutline } from "react-icons/io5";
import { SlBookOpen } from "react-icons/sl";
import { PiSignOut } from "react-icons/pi";
import Utils from "../utils/utils";
import PrivateRoute from "./PrivateRoute";

const Upperbar = ({ user, token, role, tab, setHeading }) => {
  const navigate = useNavigate();
  const { avatar } = user;

  const handleLogout = () => {
    Utils.logOut();
    navigate("/signin");
  };

  return (
    <PrivateRoute token={token}>
      <div bkl="UpperBar" className="navbar shadow-md z-20">
        <div className="flex-none">
          <label
            htmlFor="my-drawer-2"
            className="btn drawer-button lg:hidden p-2 hover:bg-purple-100"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              className="h-6 w-6 stroke-current text-pink-800 hover:text-pink-700"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 6h16M4 12h16M4 18h16"
              ></path>
            </svg>
          </label>
        </div>

        <div className="flex-1">
          <a className="ml-2 text-2xl xs:text-xl font-bold  transition-all duration-500 ">
            {tab}
          </a>
        </div>

        <div className="flex-none gap-2 xs:gap-0">
          <div className="form-control">
            {/* <input
              type="text"
              value={"Hey ! " + Utils.getUserFirstName(user.name)}
              disabled={true}
              placeholder="Search"
              className="input  w-24 md:w-auto truncate"
            /> */}
            <p className="text-pink-800 px-3 font-semibold text-md leading-6">
              <span className="text-gray-600 font-normal ">Hey ! </span>{" "}
              {"  " + Utils.getUserFirstName(user.name)}
            </p>
          </div>
          <div className="dropdown  dropdown-hover dropdown-bottom dropdown-end ">
            <div
              tabIndex={0}
              role="button"
              className="btn btn-ghost btn-circle  avatar"
            >
              <div className="w-10 rounded-full">
                {avatar ? (
                  <img
                    alt={Utils.getUserAvatar(user.name)}
                    src={avatar}
                    loading="lazy"
                  />
                ) : (
                  <div
                    className={`w-10 h-10 rounded-full text-md font-semibold flex justify-center items-center overflow-hidden bg-pink-700  text-white`}
                  >
                    {Utils.getUserAvatar(user.name)}
                  </div>
                )}
              </div>
            </div>

            <ul className="dropdown-content menu bg-base-100 rounded-box w-52 p-2 shadow ">
              <li className="pl-4 font-semibold mt-1 mb-2">Profile</li>
              <li>
                <RouterLink
                  to="/profile"
                  className="flex gap-4 items-center"
                  onClick={() => setHeading("Profile")}
                >
                  <IoPersonOutline />
                  <p>My Profile</p>
                </RouterLink>
              </li>
              <li>
                <RouterLink
                  to="/course"
                  className="flex gap-4 items-center"
                  onClick={() => setHeading("Live Sessions")}
                >
                  <SlBookOpen />
                  <p>My Course</p>
                </RouterLink>
              </li>
              <li>
                <button
                  className="flex gap-4 text-white bg-red-600 hover:bg-red-500 items-center"
                  onClick={handleLogout}
                >
                  <PiSignOut />
                  <p>Sign Out</p>
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </PrivateRoute>
  );
};

export default Upperbar;

{
  /* <div className="w-full flex gap-2 items-center xm:flex-col-reverse">
          <div className="w-1/2 lg:w-[50%] md:w-full ml-5">
            <form className="flex items-center gap-2">
              <div className="relative w-full">
                <input
                  type="text"
                  id="simple-search"
                  className="bg-white border border-gray-200 text-gray-900 text-sm rounded-lg w-full pl-5 p-2.5
                     focus:ring-blue-500 focus:border-blue-500 hover:shadow-md h-10
                     dark:bg-pink-700 dark:border-pink-600 dark:text-white dark:placeholder-gray-400 dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  placeholder="Search by concepts, lectures, assignment etc..."
                  required
                  autoComplete="off"
                />
              </div>
            </form>
          </div> */
}

{
  /* <div className="w-1/2 flex items-center gap-2 justify-end pr-1 flex-wrap">
            <div className="flex items-center gap-6 text-lg px-5">
              <MdOutlineMessage />
              <IoIosNotificationsOutline />
            </div> */
}

{
  /* <div className="relative inline-block text-left md:pr-3"> */
}
